export default "__VITE_PUBLIC_ASSET__9d9a4077__"